module.exports = __webpack_public_path__ + "static/img/pic_1.f4556623.png";